export default function IconAlertInfo() {
  return (
    <svg version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M12,23.501c-6.341,0 -11.5,-5.159 -11.5,-11.5c0,-6.341 5.159,-11.5 11.5,-11.5c6.341,0 11.5,5.159 11.5,11.5c0,6.341 -5.159,11.5 -11.5,11.5Zm0,-22c-5.79,-1.33227e-15 -10.5,4.71 -10.5,10.5c0,5.79 4.71,10.5 10.5,10.5c5.79,0 10.5,-4.71 10.5,-10.5c0,-5.79 -4.71,-10.5 -10.5,-10.5Z" />
        <path d="M13,17.505c-0.827,0 -1.5,-0.673 -1.5,-1.5v-6.5h-1.5c-0.276,0 -0.5,-0.224 -0.5,-0.5c0,-0.276 0.224,-0.5 0.5,-0.5h1.5c0.551,0 1,0.449 1,1v6.5c0,0.276 0.224,0.5 0.5,0.5h1.5c0.276,0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5h-1.5Z" />
        <path d="M11.745,7.5c-0.414,0 -0.75,-0.336 -0.75,-0.75c0,-0.414 0.336,-0.75 0.75,-0.75c0.414,0 0.75,0.336 0.75,0.75c0,0.414 -0.336,0.75 -0.75,0.75Z" />
      </g>
    </svg>
  )
}
